<template>
  <div class="container pt-3 mb-5">
    <h2 class="mb-3">Oceni rezultate</h2>
    <p>Sada nam molim te odgovori kako ti se čine ovi rezultati.</p>

    <b-form-group label="Koliko te dobro opisuju ovi rezultati?">
      <b-form-radio-group id="radio-group-1" v-model="opis" name="opis" stacked>
        <b-form-radio value="1">Vrlo loše me opisuju</b-form-radio>
        <b-form-radio value="2">Loše me opisuju</b-form-radio>
        <b-form-radio value="3">Osrednje me opisuju</b-form-radio>
        <b-form-radio value="4">Dobro me opisuju</b-form-radio>
        <b-form-radio value="5">Odlično me opisuju</b-form-radio>
      </b-form-radio-group>
    </b-form-group>

    <b-form-group label="Koliko ti je razumljiv ovaj način prikaza i opisa tvojih rezultata?">
      <b-form-radio-group id="radio-group-2" v-model="razumljiv" name="razumljiv" stacked>
        <b-form-radio value="1">Nimalo razumljiv</b-form-radio>
        <b-form-radio value="2">Jedva razumljiv</b-form-radio>
        <b-form-radio value="3">Donekle razumljiv</b-form-radio>
        <b-form-radio value="4">Prilično razumljiv</b-form-radio>
        <b-form-radio value="5">U potpunosti razumljiv</b-form-radio>
      </b-form-radio-group>
    </b-form-group>

    <b-form-group label="Koliko ti je ova informacija korisna u planiranju karijere?">
      <b-form-radio-group id="radio-group-3" v-model="korisno" name="korisno" stacked>
        <b-form-radio value="1">Nimalo korisna</b-form-radio>
        <b-form-radio value="2">Malo korisna</b-form-radio>
        <b-form-radio value="3">Donekle korisna</b-form-radio>
        <b-form-radio value="4">Dosta korisna</b-form-radio>
        <b-form-radio value="5">Vrlo korisna</b-form-radio>
      </b-form-radio-group>
    </b-form-group>

    <div class="text-center pt-3">
      <b-button variant="primary" size="lg" @click.prevent="evaluate" :disabled="!evaluated">
        <b-spinner small v-if="sending"></b-spinner>
        <span v-else>Oceni rezultate</span>
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Evaluate",
  data() {
    return {
      sending: false,
      opis: null,
      korisno: null,
      razumljiv: null
    };
  },
  computed: {
    evaluated() {
      return (
        this.$store.getters['test/testId'] != null && this.opis != null && this.razumljiv != null && this.korisno != null
      );
    }
  },
  methods: {
    evaluate() {
      this.sending = true;
      this.$store
        .dispatch("test/evaluateResults", {
          opis: this.opis,
          razumljiv: this.razumljiv,
          korisno: this.korisno
        })
        .then(res => {
          this.sending = false;
          this.$router.push({ name: "finish" });
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style>
</style>